// @flow
import type { BlocContent } from 'types/NewsletterBloc';

export function getFirstBlocText(blocs: Array<BlocContent>, limit: ?number): string {
  let output = '';

  if (blocs.length === 0) {
    return output;
  }

  const textTagName = blocs.find(bloc => bloc.type === 'element' && bloc.tagName === 'p');

  if (!textTagName || !textTagName.children || textTagName.children.length === 0) {
    return output;
  }

  const { children } = textTagName;
  const extractText = (children = []): void => {
    // $FlowFixMe
    children.length > 0 && children.forEach(child => {
      if (child.type === 'text') {
        output += (child && child.text) || '';
      } else if(child.type === 'element' && child.children) {
        extractText(child.children);
      }
    });
  };

  // Parse recursive bloc and save text in 'ouput' variable
  extractText(children);

  if (limit && limit > 0) {
    output = output.substr(0, limit);
  }

  return output;
}
